import React from "react";

export default function TradeNew({ fill }) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4676_36814)">
        <path
          d="M9.625 3.44141L5.625 7.43141H8.625V14.4414H10.625V7.43141H13.625L9.625 3.44141ZM16.625 17.4514V10.4414H14.625V17.4514H11.625L15.625 21.4414L19.625 17.4514H16.625Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_4676_36814">
          <rect
            width="24"
            height="24"
            fill={fill}
            transform="translate(0.625 0.441406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
